export enum PricingModel {
  Standard = "Standard",
  Package = "Package",
  Volume = "Volume",
  Tiered = "Tiered",
  Custom = "Custom",
}

export enum ItemBillingType {
  Term = "Term",
  Recurring = "Recurring",
  TermPlusRecurring = "TermPlusRecurring",
}

export enum RecurringBillingInterval {
  Day = "Day",
  Week = "Week",
  Month = "Month",
  Year = "Year",
}

export enum BillingStartFromInterval {
  Immediately = "Immediately",
  After = "After",
}

export enum ItemBillingStartAfterInterval {
  Year = "Year",
  Month = "Month",
  Week = "Week",
  Day = "Day",
}

export enum ItemBillingEnds {
  After = "After",
  OnCancellation = "On Cancellation",
}

export enum ItemBillingEndsAfterInterval {
  Payments = "Payments",
  Year = "Years",
  Month = "Months",
  Week = "Weeks",
  Day = "Days",
}

// export enum ItemRenewalInterval {
//     None = 'None',
//     Month = 'Month',
//     Year = 'Year',
// }

export enum ItemIncreasePriceInterval {
  None = "None",
  OnRenewal = "On Renewal",
  Every6Month = "Every 6 Months",
  EveryYear = "Every  Year",
  EveryJanuary = "Every January",
  EveryFebruary = "Every February",
  EveryMarch = "Every March",
  EveryApril = "Every April",
  EveryMay = "Every May",
  EveryJune = "Every June",
  EveryJuly = "Every July",
  EveryAugust = "Every August",
  EverySeptember = "Every September",
  EveryOctober = "Every October",
  EveryNovember = "Every November",
  EveryDecember = "Every December", 
}

export enum RecurringFeeInterval {
  None = "None",
  OnRenewal = "On Renewal",
  Every6Month = "Every 6 Months",
  EveryYear = "Every Year",
  EveryJanuary = "Every January",
  EveryFebruary = "Every February",
  EveryMarch = "Every March",
  EveryApril = "Every April",
  EveryMay = "Every May",
  EveryJune = "Every June",
  EveryJuly = "Every July",
  EveryAugust = "Every August",
  EverySeptember = "Every September",
  EveryOctober = "Every October",
  EveryNovember = "Every November",
  EveryDecember = "Every December",
}

export enum ItemIncreasePriceBy {
  Percent = "Percent",
  Amount = "Amount",
}

export enum TierMode {
  //Tiers apply progressively as quantity increases
  Graduated = "Graduated",
  //All unit price based on final tier reached
  Volume = "Volume",
}

export enum ItemReOrderIntervals {
  None = "None",
  TwoWeeks = "Two Weeks",
  ThreeWeeks = "Three Weeks",
  OneMonth = "One Month",
  FiveWeeks = "Five Weeks",
  SixWeeks = "Six Weeks",
  SevenWeeks = "Seven Weeks",
  TwoMonths = "Two Months",
  ThreeMonths = "Three Months",
  FourMonths = "Four Months",
  FiveMonths = "Five Months",
  SixthMonths = "Sixth Months",
}

export const ItemReOrderDurations = {
  None: 0,
  "Two Weeks": 14,
  "Three Weeks": 21,
  "One Month": 30,
  "Five Weeks": 35,
  "Six Weeks": 42,
  "Seven Weeks": 49,
  "Two Months": 60,
  "Three Months": 90,
  "Four Months": 120,
  "Five Months": 150,
  "Sixth Months": 180,
};
